const currencyMap: { [x: string]: string } = {
    EUR: "Euro",
    USD: "Dollar",
    YEN: "Yen",
    GBP: "Brit. Pfund",
    HKD: "Hongong-Dollar",
    CHF: "Franken"
};

/**
 * Will return friendly currency names if available else the currency iso code.
 */
export const friendlyCurrency = (currencyIsoCode: string): string =>
    currencyMap[currencyIsoCode.toUpperCase()] || currencyIsoCode;
